import { NgModule } from "@angular/core";
import { PageTitleModule } from "@app/components/page-title/page-title.module";
import { TableModule } from "primeng/table";
import { DatePipe, NgClass, NgForOf, NgIf, NgStyle } from "@angular/common";
import {
  MedBubbleModule,
  MedCheckboxModule,
  MedDirectiveSharedModule,
  MedPaginationModule,
  MedRadioGroupModule,
} from "@mk/med-ui";
import { TooltipModule } from "primeng/tooltip";
import { ProgressBarModule } from "primeng/progressbar";
import {
  MedIconArrowDownModule,
  MedIconPlusModule,
  MedIconTriangleDownModule,
  MedIconTriangleUpModule,
} from "@mk/med-icons";
import { LoaderModule } from "@app/components/loader/loader.module";
import { DistributionsMzuComponent } from "@app/components/distributions/mzu/dustributions.mzu.component";

@NgModule({
  declarations: [
    DistributionsMzuComponent,
  ],
  imports: [
    PageTitleModule,
    TableModule,
    NgForOf,
    NgIf,
    NgStyle,
    NgClass,
    DatePipe,
    MedCheckboxModule,
    MedPaginationModule,
    MedRadioGroupModule,
    TooltipModule,
    ProgressBarModule,
    MedBubbleModule,
    MedIconPlusModule,
    MedIconArrowDownModule,
    MedIconTriangleDownModule,
    MedIconTriangleUpModule,
    MedDirectiveSharedModule,
    LoaderModule,

  ],
  exports: [],
})
export class DistributionsMZUModule {}
